import { Table, TableBody } from '@mui/material';
import { BaseItem, Column, StickyGroupBand } from '../VirtualizedTable.types';
import { useStyles } from '../virtualizedTable.styles';
import StickyGroupRow from './StickyGroupRow';
import StickyGroupSlot from './StickyGroupSlot';

interface StickyGroupBandsProps<T extends BaseItem> {
  bands: StickyGroupBand<T>[];
  bandHeight: number;
  columns: Column<T>[];
  hasRowCheckbox: boolean;
  hasRowActions: boolean;
  hasHideColumnsButton: boolean;
}

const StickyGroupBands = <T extends BaseItem>({
  bands,
  bandHeight,
  columns,
  hasRowCheckbox,
  hasRowActions,
  hasHideColumnsButton,
}: StickyGroupBandsProps<T>) => {
  const { classes } = useStyles();

  return (
    <>
      {bands.map((band, depth) => (
        <StickyGroupSlot
          key={band.row.id}
          top={depth * bandHeight + band.push}
          height={bandHeight}
          zIndex={bands.length - depth}
          isDeepest={depth === bands.length - 1}
        >
          <Table className={classes.table}>
            <TableBody>
              <StickyGroupRow<T>
                row={band.row}
                position={band.position}
                columns={columns}
                hasRowCheckbox={hasRowCheckbox}
                hasRowActions={hasRowActions}
                hasHideColumnsButton={hasHideColumnsButton}
              />
            </TableBody>
          </Table>
        </StickyGroupSlot>
      ))}
    </>
  );
};

export default StickyGroupBands;
